import toast from "react-hot-toast"

export const say = (
  text,
  prompt = true,
  lang = "en",
  rate = 0.7,
  cancels = false
) => {
  const m = new SpeechSynthesisUtterance()
  m.text = text
  m.rate = rate
  m.lang = lang
  if (cancels) {
    window.speechSynthesis.cancel()
    toast.dismiss()
  }
  window.speechSynthesis.speak(m)
  if (prompt) {
    toast(text, {
      style: {
        fontSize: "20px",
      },
      position: "bottom-center",
      icon: "🗣️",
    })
  }
}
